import React, { useEffect, useState } from "react";
import { bakeStreetSquareLogo } from "./constants";
import {
  Avatar,
  Box,
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Link,
  Typography,
} from "@mui/material";
import { isAdmin } from "./util";
import bkstApi from "../api";
import CloseIcon from "@mui/icons-material/Close";

const AVATAR_SIZES = {
  sm: { width: 32, height: 32 },
  md: { width: 40, height: 40 },
  lg: { width: 50, height: 50 },
};

export default function UserAvatar(props) {
  const { uid, by, onClick, size = "sm" } = props;

  const [user, setUser] = useState("");
  const [open, setOpen] = useState(false);

  const style = props.style || AVATAR_SIZES[size] || AVATAR_SIZES.sm;

  useEffect(() => {
    if (open && !user) {
      if (isAdmin(uid)) {
        setUser({ firstName: "BakeStreet", role: "admin" });
      } else if (uid) {
        bkstApi(`/my/staff/${uid}`).then((res) => {
          setUser(res.data.user);
        });
      }
    }
  }, [open]);

  const handleClick = (e) => {
    if (onClick) {
      e.preventDefault();
      e.stopPropagation();
      onClick(uid);
      return;
    }
    getUser();
  };

  const getUser = () => {
    if (isAdmin(uid)) {
      setUser({ firstName: "BakeStreet", role: "admin" });
      setOpen(true);
    } else if (uid) {
      bkstApi(`/my/staff/${uid}`).then((res) => {
        setUser(res.data.user);
        setOpen(true);
      });
    }
  };

  let img = "";
  if (by === "bkst" || isAdmin(uid)) {
    img = bakeStreetSquareLogo;
  } else if (uid) {
    img = `https://storage.googleapis.com/bakestreet-f55a0.appspot.com/img/u/${props.uid}.webp`;
  }

  return (
    <span>
      <Box sx={{ display: "inline-flex", alignItems: "center" }}>
        <Link onClick={handleClick}>
          <Avatar src={img} style={style} />
        </Link>
      </Box>
      <Dialog onClose={() => setOpen(false)} open={open} maxWidth="sm" fullWidth>
        <DialogTitle>
          User Details
          <IconButton
            onClick={() => setOpen(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box pt={2}>
            <Grid container spacing={4}>
              <Grid item xs={6}>
                <img src={img} style={{ width: "100%", border: "1px solid #DDD" }} />
              </Grid>
              <Grid item xs={6}>
                <Typography variant="h4">
                  {user.firstName} {user.lastName}
                </Typography>
                <Chip label={user.role} />
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
      </Dialog>
    </span>
  );
}
